import { memo, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box, CircularProgress } from "@mui/material";
import Sortable from "sortablejs";
import { newTicketsUseStyles } from "../../NewTickets";
import { IState } from "../../../../../../redux/reducers/rootReducers";
import CustomCard1 from "../../../../../common/customCard1";
import LoadMoreNewTickets from "../../LoadMore/LoadMoreNewTickets";

const PAGE_SIZE = 20;

const NewTicketsList = memo(({ AllTickets = [] }: any) => {
  const classes = newTicketsUseStyles();
  const FiltersVal: any = useSelector((state: IState) => state?.filtersTicketManagementReducer);
  const shrinkGroupsVal: any = useSelector(
    (state: IState) =>
      state?.LayoutTicketManagementReducer?.groupShrinked
  );
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  useEffect(() => {
    const ticketList: any = document.getElementById("newTicketsHodler");

    if (!ticketList) return;

    const sortable =  Sortable.create(ticketList, {
      group: {
        name: "list",
        put: false,
        pull: "clone",
      },
      onStart: function () {
        const evt: any = document.getElementsByTagName("html");
        evt[0].classList.add("newItemDragged");
      },
      onEnd: function () {
        const evt: any = document.getElementsByTagName("html");
        evt[0].classList.remove("newItemDragged");
      },
    });
    //  return () => {
    //   sortable.destroy();
    // };
  }, []);

useEffect(() => {
  setVisibleCount(PAGE_SIZE);
  setIsLoadingMore(false);
}, [FiltersVal]);

useEffect(() => {
  setVisibleCount(prev => {
    const next =
      prev === 0 ? PAGE_SIZE : Math.min(prev, AllTickets.length);

    return prev === next ? prev : next;
  });

  setIsLoadingMore(prev => (prev ? false : prev));
}, [AllTickets]);

  const handleScroll = (e: any) => {
    const { scrollTop, clientHeight, scrollHeight } = e.currentTarget;

    if (
      scrollTop + clientHeight >= scrollHeight - 100 &&
      visibleCount < AllTickets.length &&
      !isLoadingMore
    ) {
      setIsLoadingMore(true);

      setTimeout(() => {
        setVisibleCount((prev) =>
          Math.min(prev + PAGE_SIZE, AllTickets.length)
        );

        setIsLoadingMore(false);
      }, 300);
    }
  };

  return (
    <Box
      className={`${classes.row} ${classes.flxWrap}`}
      id="newTicketsHodler"
      onScroll={handleScroll}
      sx={{
        overflowY: "auto",
        height: "100%",
      }}
    >
      {AllTickets &&
        AllTickets
          .slice(0, visibleCount)
          .map((i: any, index: number) => (
            <div
              key={i.id || index}
              className={`${
                shrinkGroupsVal ? "col-3" : "col-6"
              } p-2p userItem newTicketsTiles`}
              data-ticket-id={i.id}
              data-mytickets="newTickets"
              data-new-tickets={true}
              data-ticket-priority={i.ticketLogs.priorityId}
              data-ticket-status={i.ticketLogs.statusId}
              data-ticket-ownerid={i.ticketLogs.agentId}
            >
              <CustomCard1
                id={i.id}
                sourceCode={i?.sourceCode}
                ticket={i.ticketLogs}
              />
            </div>
          ))}

      {isLoadingMore && (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            py: 2,
          }}
        >
          <CircularProgress size={24} />
        </Box>
      )}

      {!isLoadingMore &&
        visibleCount >= AllTickets.length &&
        AllTickets.length > 0 && (
          <LoadMoreNewTickets />
        )}
    </Box>
  );
});

export default NewTicketsList;